import { useState, useEffect } from "react";
import { signIn } from "../auth";
import { supabase } from "../supabase";

const BACKEND = "https://smart-crm-production.up.railway.app";

const conversations = [
  { name: "Fatima", channel: "WhatsApp", avatarBg: "#25D366", msgs: [
    { t: "Bonjour, vous avez des abayas ?", c: "client" },
    { t: "Oui ! À 35 000 FCFA du S au XXL 😊 Quelle taille ?", c: "ai", cls: "wa" },
  ]},
  { name: "sara_mode", channel: "Instagram", avatarBg: "#E1306C", msgs: [
    { t: "C'est combien ce hijab ? 😍", c: "client" },
    { t: "8 000 FCFA en 12 couleurs ✨ Laquelle vous tente ?", c: "ai", cls: "ig" },
  ]},
  { name: "Karim", channel: "Facebook", avatarBg: "#0084FF", msgs: [
    { t: "Vous livrez à Dakar ?", c: "client" },
    { t: "Oui, 48-72h à Dakar 🚚 Qu'est-ce qui vous intéresse ?", c: "ai", cls: "fb" },
  ]},
];

const aiBg = { wa: "#25D366", ig: "#E1306C", fb: "#0084FF" };

function AnimatedMessages({ small }) {
  const [messages, setMessages] = useState([]);
  const [convIdx, setConvIdx] = useState(0);
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    const conv = conversations[convIdx];
    setMessages(conv.msgs);
    setVisible([]);
    conv.msgs.forEach((_, i) => {
      setTimeout(() => setVisible(prev => [...prev, i]), 200 + i * 500);
    });
  }, [convIdx]);

  useEffect(() => {
    const interval = setInterval(() => setConvIdx(prev => (prev + 1) % conversations.length), 4000);
    return () => clearInterval(interval);
  }, []);

  const conv = conversations[convIdx];
  const fs = small ? "10px" : "11px";
  const pad = small ? "6px 9px" : "8px 12px";
  const avSize = small ? "22px" : "26px";
  const avFs = small ? "9px" : "10px";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: small ? "7px" : "10px" }}>
      {messages.map((m, i) => (
        <div key={`${convIdx}-${i}`} style={{
          display: "flex", alignItems: "flex-end", gap: "8px",
          flexDirection: m.c === "ai" ? "row-reverse" : "row",
          opacity: visible.includes(i) ? 1 : 0,
          transform: visible.includes(i) ? "translateY(0)" : "translateY(10px)",
          transition: "all 0.4s ease",
        }}>
          <div style={{ width: avSize, height: avSize, borderRadius: "50%", background: m.c === "ai" ? conv.avatarBg : "#444", display: "flex", alignItems: "center", justifyContent: "center", fontSize: avFs, fontWeight: "600", color: "#fff", flexShrink: 0 }}>
            {m.c === "ai" ? "IA" : conv.name[0]}
          </div>
          <div>
            {i === 0 && <div style={{ fontSize: "8px", color: "#666", marginBottom: "3px" }}>{m.c === "ai" ? conv.channel : conv.name}</div>}
            <div style={{ padding: pad, borderRadius: m.c === "client" ? "4px 12px 12px 12px" : "12px 4px 12px 12px", background: m.c === "client" ? "#2a2a2a" : aiBg[m.cls], color: "#fff", fontSize: fs, lineHeight: "1.4", maxWidth: small ? "180px" : "220px" }}>
              {m.t}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function LeftPanel({ small }) {
  return (
    <div style={{ flex: 1, minWidth: small ? "100%" : "50%", background: "#0f0f0f", padding: small ? "28px 24px 24px" : "40px", display: "flex", flexDirection: "column", justifyContent: "space-between", position: "relative", overflow: "hidden", flexShrink: 0 }}>
      <div style={{ position: "absolute", width: small ? "200px" : "350px", height: small ? "200px" : "350px", borderRadius: "50%", background: "#C04828", filter: "blur(70px)", opacity: 0.25, top: "-80px", left: "-40px" }} />
      <div style={{ position: "absolute", width: small ? "150px" : "250px", height: small ? "150px" : "250px", borderRadius: "50%", background: "#FF6B3D", filter: "blur(60px)", opacity: 0.2, bottom: "-60px", right: "-40px" }} />
      <div style={{ display: "flex", alignItems: "center", gap: "10px", position: "relative", zIndex: 1, marginBottom: small ? "16px" : 0 }}>
        <div style={{ width: small ? "30px" : "34px", height: small ? "30px" : "34px", background: "linear-gradient(135deg,#C04828,#FF6B3D)", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="18" height="18" viewBox="0 0 22 22" fill="none">
            <rect x="2" y="4" width="18" height="12" rx="3.5" fill="white"/>
            <path d="M8 16 L5 20 L13 16" fill="white"/>
            <circle cx="7" cy="10" r="1.4" fill="#C04828"/>
            <circle cx="11" cy="10" r="1.4" fill="#C04828"/>
            <circle cx="15" cy="10" r="1.4" fill="#C04828"/>
          </svg>
        </div>
        <span style={{ color: "#fff", fontWeight: "500", fontSize: small ? "14px" : "15px" }}>Hellodia CRM</span>
      </div>
      <div style={{ position: "relative", zIndex: 1, flex: small ? 0 : 1, display: "flex", flexDirection: "column", justifyContent: "center", gap: small ? "14px" : "32px", padding: small ? 0 : "40px 0" }}>
        <div style={{ color: "#fff", fontSize: small ? "16px" : "26px", fontWeight: "500", lineHeight: "1.35", letterSpacing: "-0.3px" }}>
          Votre business répond, vend et encaisse...<br />
          <span style={{ color: "#FF6B3D" }}>même quand vous dormez.</span>
        </div>
        <AnimatedMessages small={small} />
      </div>
      {!small && <div style={{ position: "relative", zIndex: 1 }}><p style={{ color: "#555", fontSize: "11px" }}>Rejoignez <span style={{ color: "#888" }}>+500 business</span> qui automatisent leurs ventes</p></div>}
    </div>
  );
}

export default function Login({ onLogin, goToRegister }) {
  const [loginMethod, setLoginMethod] = useState("email");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("+212");
  const [otpCode, setOtpCode] = useState(["", "", "", "", "", ""]);
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [rememberMe, setRememberMe] = useState(false); 

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  // Connexion email classique
  async function handleEmailLogin(e) {
  e.preventDefault();
  setLoading(true);
  setError("");
  
  // Configurer la durée de session selon "se souvenir de moi"
  if (rememberMe) {
    await supabase.auth.setSession({ access_token: '', refresh_token: '' });
  }
  
  const { data, error } = await signIn(email, password);
  if (error) { setError("Email ou mot de passe incorrect"); setLoading(false); return; }
  onLogin(data.user);
}

  // Envoyer OTP WhatsApp
  async function handleSendOTP() {
    if (!phone) { setError("Entrez votre numéro WhatsApp"); return; }
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${BACKEND}/api/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: countryCode + phone.replace(/^0/, '') })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Numéro non trouvé"); setLoading(false); return; }
      setOtpSent(true);
    } catch (e) {
      setError("Erreur réseau");
    }
    setLoading(false);
  }

  // Gérer saisie OTP case par case
  function handleOtpInput(val, idx) {
    const newOtp = [...otpCode];
    newOtp[idx] = val.slice(-1);
    setOtpCode(newOtp);
    if (val && idx < 5) {
      document.getElementById(`otp-${idx + 1}`)?.focus();
    }
  }

  function handleOtpKeyDown(e, idx) {
    if (e.key === "Backspace" && !otpCode[idx] && idx > 0) {
      document.getElementById(`otp-${idx - 1}`)?.focus();
    }
  }

  // Vérifier OTP et connecter
  async function handleVerifyOTP() {
    const code = otpCode.join("");
    if (code.length < 6) { setError("Entrez le code complet"); return; }
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${BACKEND}/api/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: countryCode + phone.replace(/^0/, '') })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Code invalide"); setLoading(false); return; }

      // Connecter via magic link
      if (data.magic_link) {
        window.location.href = data.magic_link;
      } else if (data.email) {
        // Connexion directe avec email fictif
        const { data: signInData } = await supabase.auth.signInWithPassword({
          email: data.email,
          password: `otp_${phone}_hellodia`
        });
        // Session longue si "se souvenir de moi"
        if (rememberMe) {
          await supabase.auth.updateUser({});
        }
        if (signInData?.user) onLogin(signInData.user);
        else setError("Erreur de connexion — contactez le support");
      }
    } catch (e) {
      setError("Erreur réseau");
    }
    setLoading(false);
  }

  const inputStyle = {
    width: "100%", padding: "10px 12px",
    border: "0.5px solid var(--color-border-secondary)",
    borderRadius: "8px", fontSize: "13px",
    color: "var(--color-text-primary)",
    background: "var(--color-background-primary)", outline: "none",
  };

  const formPanel = (
    <div style={{ width: isMobile ? "100%" : "50%", minWidth: isMobile ? "100%" : "50%", background: "var(--color-background-primary)", padding: isMobile ? "24px" : "40px", display: "flex", flexDirection: "column", justifyContent: "center" }}>

      {/* Tabs Connexion/Inscription */}
      <div style={{ display: "flex", background: "var(--color-background-secondary)", borderRadius: "8px", padding: "3px", marginBottom: "24px", border: "0.5px solid var(--color-border-tertiary)" }}>
        <button style={{ flex: 1, padding: "7px", borderRadius: "6px", fontSize: "13px", fontWeight: "500", border: "none", cursor: "pointer", background: "#C04828", color: "#fff" }}>Connexion</button>
        <button onClick={goToRegister} style={{ flex: 1, padding: "7px", borderRadius: "6px", fontSize: "13px", fontWeight: "500", border: "none", cursor: "pointer", background: "transparent", color: "var(--color-text-secondary)" }}>Créer un compte</button>
      </div>

      <div style={{ fontSize: "18px", fontWeight: "500", color: "var(--color-text-primary)", marginBottom: "3px" }}>Bon retour 👋</div>
      <div style={{ fontSize: "13px", color: "var(--color-text-secondary)", marginBottom: "20px" }}>Connectez-vous à votre espace Hellodia CRM</div>

      {/* Toggle Email / WhatsApp */}
      <div style={{ display: "flex", gap: "8px", marginBottom: "20px" }}>
        <button
          onClick={() => { setLoginMethod("email"); setError(""); setOtpSent(false); }}
          style={{ flex: 1, padding: "8px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", border: `1px solid ${loginMethod === "email" ? "#C04828" : "var(--color-border-secondary)"}`, background: loginMethod === "email" ? "#FFF5F0" : "transparent", color: loginMethod === "email" ? "#C04828" : "var(--color-text-secondary)", cursor: "pointer" }}
        >
          Email
        </button>
        <button
          onClick={() => { setLoginMethod("whatsapp"); setError(""); }}
          style={{ flex: 1, padding: "8px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", border: `1px solid ${loginMethod === "whatsapp" ? "#25D366" : "var(--color-border-secondary)"}`, background: loginMethod === "whatsapp" ? "#F0FFF4" : "transparent", color: loginMethod === "whatsapp" ? "#16A34A" : "var(--color-text-secondary)", cursor: "pointer" }}
        >
          WhatsApp
        </button>
      </div>

      {/* Formulaire Email */}
      {loginMethod === "email" && (
        <form onSubmit={handleEmailLogin}>
          <div style={{ marginBottom: "14px" }}>
            <label style={{ fontSize: "12px", fontWeight: "500", color: "var(--color-text-secondary)", marginBottom: "5px", display: "block" }}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="votre@email.com" required style={inputStyle} />
          </div>
          <div style={{ marginBottom: "14px" }}>
            <label style={{ fontSize: "12px", fontWeight: "500", color: "var(--color-text-secondary)", marginBottom: "5px", display: "block" }}>Mot de passe</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required style={inputStyle} />
          </div>
          {error && <div style={{ fontSize: "12px", color: "#dc2626", background: "#fef2f2", padding: "8px 12px", borderRadius: "8px", marginBottom: "12px" }}>{error}</div>}
          
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "14px" }}>
          <input
            type="checkbox"
            id="rememberMe"
            checked={rememberMe}
            onChange={e => setRememberMe(e.target.checked)}
            style={{ width: "14px", height: "14px", accentColor: "#C04828", cursor: "pointer" }}
          />
          <label htmlFor="rememberMe" style={{ fontSize: "12px", color: "var(--color-text-secondary)", cursor: "pointer" }}>
            Se souvenir de moi pendant 30 jours
          </label>
        </div>
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "11px", background: "#C04828", color: "#fff", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}>
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      )}

      {/* Formulaire WhatsApp OTP */}
      {loginMethod === "whatsapp" && (
        <div>
          {!otpSent ? (
            <div>
              <div style={{ marginBottom: "14px" }}>
                <label style={{ fontSize: "12px", fontWeight: "500", color: "var(--color-text-secondary)", marginBottom: "5px", display: "block" }}>
                  Numéro WhatsApp
                </label>
                <div style={{ display: "flex", gap: "8px" }}>
                  <select
                    value={countryCode}
                    onChange={e => setCountryCode(e.target.value)}
                    style={{ padding: "10px 8px", border: "0.5px solid var(--color-border-secondary)", borderRadius: "8px", fontSize: "13px", color: "var(--color-text-primary)", background: "var(--color-background-primary)", outline: "none", width: "110px", flexShrink: 0 }}
                  >
                    <option value="+212">🇲🇦 +212</option>
                    <option value="+221">🇸🇳 +221</option>
                    <option value="+225">🇨🇮 +225</option>
                    <option value="+237">🇨🇲 +237</option>
                    <option value="+228">🇹🇬 +228</option>
                    <option value="+229">🇧🇯 +229</option>
                    <option value="+223">🇲🇱 +223</option>
                    <option value="+226">🇧🇫 +226</option>
                    <option value="+224">🇬🇳 +224</option>
                    <option value="+234">🇳🇬 +234</option>
                    <option value="+233">🇬🇭 +233</option>
                    <option value="+254">🇰🇪 +254</option>
                    <option value="+256">🇺🇬 +256</option>
                    <option value="+255">🇹🇿 +255</option>
                    <option value="+250">🇷🇼 +250</option>
                    <option value="+33">🇫🇷 +33</option>
                    <option value="+32">🇧🇪 +32</option>
                    <option value="+41">🇨🇭 +41</option>
                    <option value="+34">🇪🇸 +34</option>
                    <option value="+351">🇵🇹 +351</option>
                    <option value="+44">🇬🇧 +44</option>
                    <option value="+1">🇺🇸 +1</option>
                    <option value="+1">🇨🇦 +1</option>
                  </select>
                  <input
                    type="tel"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                    placeholder="600 000 000"
                    style={{ ...inputStyle, flex: 1 }}
                  />
                </div>
                <p style={{ fontSize: "11px", color: "var(--color-text-tertiary)", marginTop: "4px" }}>
                  Le numéro sur lequel Hellodia est configuré pour votre business
                </p>
              </div>
              {error && <div style={{ fontSize: "12px", color: "#dc2626", background: "#fef2f2", padding: "8px 12px", borderRadius: "8px", marginBottom: "12px" }}>{error}</div>}
              <button onClick={handleSendOTP} disabled={loading} style={{ width: "100%", padding: "11px", background: "#25D366", color: "#fff", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}>
                {loading ? "Envoi..." : "Recevoir le code sur WhatsApp"}
              </button>
            </div>
          ) : (
            <div>
              <div style={{ fontSize: "13px", color: "var(--color-text-secondary)", marginBottom: "16px", background: "#F0FFF4", padding: "10px 12px", borderRadius: "8px", border: "1px solid #BBF7D0" }}>
                ✅ Code envoyé sur WhatsApp au <strong>{phone}</strong>
              </div>
              <label style={{ fontSize: "12px", fontWeight: "500", color: "var(--color-text-secondary)", marginBottom: "10px", display: "block" }}>
                Entrez le code à 6 chiffres
              </label>
              <div style={{ display: "flex", gap: "8px", marginBottom: "16px", justifyContent: "center" }}>
                {otpCode.map((digit, idx) => (
                  <input
                    key={idx}
                    id={`otp-${idx}`}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    onChange={e => handleOtpInput(e.target.value, idx)}
                    onKeyDown={e => handleOtpKeyDown(e, idx)}
                    style={{
                      width: "42px", height: "48px", textAlign: "center",
                      fontSize: "20px", fontWeight: "600",
                      border: `1.5px solid ${digit ? "#25D366" : "var(--color-border-secondary)"}`,
                      borderRadius: "8px", outline: "none",
                      color: "var(--color-text-primary)",
                      background: "var(--color-background-primary)",
                    }}
                  />
                ))}
              </div>
              {error && <div style={{ fontSize: "12px", color: "#dc2626", background: "#fef2f2", padding: "8px 12px", borderRadius: "8px", marginBottom: "12px" }}>{error}</div>}
              
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "14px" }}>
                <input
                  type="checkbox"
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={e => setRememberMe(e.target.checked)}
                  style={{ width: "14px", height: "14px", accentColor: "#C04828", cursor: "pointer" }}
                />
                <label htmlFor="rememberMe" style={{ fontSize: "12px", color: "var(--color-text-secondary)", cursor: "pointer" }}>
                  Se souvenir de moi pendant 30 jours
                </label>
              </div>
              <button onClick={handleVerifyOTP} disabled={loading} style={{ width: "100%", padding: "11px", background: "#25D366", color: "#fff", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}>
                {loading ? "Vérification..." : "✓ Vérifier et se connecter"}
              </button>
              <button onClick={() => { setOtpSent(false); setOtpCode(["","","","","",""]); setError(""); }} style={{ width: "100%", marginTop: "8px", padding: "9px", background: "transparent", color: "var(--color-text-secondary)", border: "0.5px solid var(--color-border-secondary)", borderRadius: "8px", fontSize: "12px", cursor: "pointer" }}>
                ← Changer de numéro
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );

  if (isMobile) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", overflowX: "hidden" }}>
        <LeftPanel small={true} />
        {formPanel}
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", overflowX: "hidden" }}>
      <LeftPanel small={false} />
      {formPanel}
    </div>
  );
}